module.exports = __webpack_public_path__ + "img/belgium-pneumonia-male.34acb7c0.png";